// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1YoC-","subheader":"ReorderModal_subheader__34Fse","listWrap":"ReorderModal_listWrap__iRuC9"};